export class DialogSelectConfig<T = any> {
  title: string;
  showAll = false;
  filter: string[];

  //to over ride label of the field
  label?: string;
  displayHint?: string;

  //List of Field Names of required items
  require?: string[];

  //List of Field Names that should be hidden on the form
  //This allows for form reuse independent on how you got to the form.
  //E.G. Truck form link would hid the truckID field
  //Vice Versa: Truck Alias link would hide the truckAliasId field
  hideFields?: string[];
  showOnly?: string[];
  //Object representing the defaults to fill the form with
  default?: Partial<T>;
  data?: T;

  //Use related Elements to pass related objects that are needed for the dialog
  //E.G Schedule Templates needs list of available Alt Weeks on that route
  //relatedElements = { altWeeks = [object1, object2,...]}
  relatedElements: unknown;

  // Button customization
  confirmButtonText?: string; // Custom text for the confirm button (defaults to "Save")
  confirmButtonSeverity?:
    | 'success'
    | 'info'
    | 'warn'
    | 'danger'
    | 'help'
    | 'primary'
    | 'secondary'
    | 'contrast'
    | null
    | undefined; // Button color/style
  cancelButtonText?: string; // Custom text for the cancel button (defaults to "Cancel")
  bypassFormCheckOnCancel?: boolean; // Whether to bypass form checks when cancelled (defaults to false)
  confirmButtonPosition?: 'left' | 'right'; // Position of confirm button (defaults to 'right')

  constructor(jsonData?: Partial<DialogSelectConfig<T>>) {
    if (jsonData) {
      Object.assign(this, jsonData);
    }
  }
}
